import { Injectable } from '@angular/core';
import { AjaxService } from './ajax.service';
import { LocalStorageService } from './local-storage.service';

@Injectable()
export class ChildService {
  private $api: string = '';
  private $local: LocalStorageService = new LocalStorageService();

  constructor(private $ajax: AjaxService) {
    this.$api = $ajax.getAPIDomain();
  }

  /**
   * 현재 사용자의 아동 목록
   */
  childrenInfo() {
    const id = this.$local.getUserId();
    return this.$ajax.httpRequest(
        'GET',
        this.$api + 'children-info/' + id,
    );
  }
}
